module.exports = __webpack_public_path__ + "static/media/planet-earth.36b4256c.svg";